var documentTitle = document.title;

var wirVermissen = '🔥 Wir vermissen dich!';
var wirFreuen = '🔥 Wir freuen uns auf dich 😊';

if(window.location.hostname == "belle-body.eu" || window.location.hostname == "belle-body.fr"){
  wirVermissen = '🔥 We miss you!';
  wirFreuen = '🔥 We look forward to seeing you 😊';
}

var PageTitleNotification = {
    Vars:{
        OriginalTitle: document.title,
        Interval: null
    },    
    On: function(notification, intervalSpeed){
        var _this = this;
        _this.Vars.Interval = setInterval(function(){
             document.title = (wirVermissen == document.title)
                                 ? wirFreuen
                                 : wirVermissen;
        }, (intervalSpeed) ? intervalSpeed : 1000);
    },
    Off: function(){
        clearInterval(this.Vars.Interval);
        document.title = documentTitle;   
    }
}

window.onblur = function () { 
  document.title = wirVermissen;
  PageTitleNotification.On();
}

window.onfocus = function () { 
  PageTitleNotification.Off();
  document.title = documentTitle; 
}

function scrollToTop() {
  window.scrollTo(0, 0);
}

function scrollToSection(section){
  if(document.getElementById(section)){
    var scrollDiv = document.getElementById(section).offsetTop - 70;
    window.scrollTo({ top: scrollDiv, behavior: 'smooth'});;
  }
}

var timerForCartNot;

var addRecommendationToCart = function(e) {
  var attribute = e.getAttribute("data-productid");
  addItemToCart(attribute);
}

function addItemToCart(variant_id) {
    data = {
      "id": variant_id,
      "quantity": 1
    }
    
    ajax.post('/cart/add.js',
              data, 
              function() {
                      document.getElementById("cartNotCont").classList.add("active");
                      clearTimeout(timerForCartNot);
                      timerForCartNot = timeoutForCart();
    		  }, true);
}

function putRecommendationToCart(variant_id) {
    data = {
      "id": variant_id,
      "quantity": 1
    }
    
    ajax.post('/cart/add.js',
              data, 
              function() {window.location.reload();}, true);
}

function timeoutForCart(){
  return setTimeout(function(){
                        document.getElementById("cartNotCont").classList.remove("active");
                     }, 5000);
}

if(document.getElementById("continueShoppingButton")){
  document.getElementById("continueShoppingButton").addEventListener("click", function(){
    document.getElementById("cartNotCont").classList.remove("active");
    clearTimeout(timerForCartNot);
  });
}

if(document.getElementById("toTheCartButton")){
  document.getElementById("toTheCartButton").addEventListener("click", function(){
    location.href="/cart";
  });
}